export default __webpack_public_path__ + "static/media/calculator.e480bc76.png";